import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Image, Text, withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { toggleRegisterAccountModal } from "@clarion/foundation/dist/Settings/actions/globalActions";
import { toggleIsRegistrationBannerOpen } from "@clarion/foundation/dist/Settings/actions/registerBannerActions";
import { toggleLoadRegisterModals } from "@clarion/foundation/dist/Settings/actions/loaderActions";
import { cookies } from "@clarion/foundation/dist/Utils/cookieUtils";
import { REGISTRATIONBANNER_COOKIE } from "@clarion/foundation/dist/Settings/constants/cookies";
import { userIsLoggedIn } from "@clarion/foundation/dist/Utils/userUtils";
import WithFieldsCheck from "@clarion/foundation/dist/Helpers/containers/WithFieldsCheck/index";
import "./index.css";
const RegistrationBanner = ({
  sitecoreContext,
  fields
}) => {
  const isLoggedIn = userIsLoggedIn(sitecoreContext);
  const dispatch = useDispatch();
  const [hideBanner, setHideBanner] = useState(false);
  const closeBanner = () => {
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 5);
    cookies.set({
      name: REGISTRATIONBANNER_COOKIE,
      value: "set",
      expires: expiryDate.toUTCString()
    });
    setHideBanner(true);
    dispatch(toggleIsRegistrationBannerOpen(false));
  };
  const openRegisterModal = () => {
    dispatch(toggleLoadRegisterModals(true));
    dispatch(toggleRegisterAccountModal(true));
  };
  useEffect(() => {
    if (isLoggedIn) {
      closeBanner();
    }
  }, []);
  useEffect(() => {
    const registerBannerCookie = cookies.get(REGISTRATIONBANNER_COOKIE);
    if (registerBannerCookie) {
      setHideBanner(true);
      dispatch(toggleIsRegistrationBannerOpen(false));
    } else {
      setHideBanner(false);
    }
  }, []);
  if (hideBanner) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "registration-banner",
    className: "registration-banner bg--coral"
  }, /*#__PURE__*/React.createElement("div", {
    className: "registration-banner__inner wrapper wrapper--wide"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "registration-banner__icon",
    field: fields.Icon
  }), /*#__PURE__*/React.createElement("div", {
    className: "registration-banner__main"
  }, /*#__PURE__*/React.createElement("div", {
    className: "registration-banner__messaging"
  }, /*#__PURE__*/React.createElement("span", {
    className: "registration-banner__title"
  }, /*#__PURE__*/React.createElement(Text, {
    field: fields.TitleStart
  }), /*#__PURE__*/React.createElement("span", {
    className: "registration-banner__title-end"
  }, " ", /*#__PURE__*/React.createElement(Text, {
    field: fields.TitleEnd
  }))), /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "registration-banner__description",
    field: fields.Description
  })), /*#__PURE__*/React.createElement("button", {
    onClick: openRegisterModal,
    className: "registration-banner__CTA btn btn--small btn--secondary btn--coral"
  }, fields.CtaLabel.value))), /*#__PURE__*/React.createElement("button", {
    onClick: closeBanner,
    className: "registration-banner__close-btn"
  }, /*#__PURE__*/React.createElement("span", {
    className: "visually-hidden"
  }, fields.Close.value)));
};
const RegistrationBannerWithFieldsCheck = WithFieldsCheck(RegistrationBanner);
export default withSitecoreContext()(RegistrationBannerWithFieldsCheck);